import './assets/LocalNavbar.css';const root = "_root_1hpev_2";
const container = "_container_1hpev_29";
const innerWrapper = "_innerWrapper_1hpev_38";
const middle = "_middle_1hpev_44";
const dropdown = "_dropdown_1hpev_49";
const navigationGroup = "_navigationGroup_1hpev_59";
const linkGroup = "_linkGroup_1hpev_64";
const linkColumn = "_linkColumn_1hpev_69";
const localLink = "_localLink_1hpev_91";
const right = "_right_1hpev_124";
const burger = "_burger_1hpev_128";
const search = "_search_1hpev_133";
const readMore = "_readMore_1hpev_137";
const divider = "_divider_1hpev_143";
const LocalNavbarStyles = {
  root,
  container,
  innerWrapper,
  middle,
  dropdown,
  navigationGroup,
  linkGroup,
  linkColumn,
  localLink,
  right,
  burger,
  search,
  readMore,
  divider
};
export {
  LocalNavbarStyles as L
};
